import {
  REDIRECT,
  useTranslation,
} from "@/imports-files/pages/clients/candidates/kanban";
import Modal from "@/components/common-modal/modal";

export function SkipModal({ setBtnPopup, router }) {
  const { t } = useTranslation();
  
  return (
    <Modal
      type="confirmation"
      className={`CandidateFilterModal`}
      noCloseIcon={true}
      message={t("modal:confirmation:skip_step")}
      texts={{
        button1_text: t("button:cancel"),
        button2_text: t("button:continue_skip"),
      }}
      closeModal={() => setBtnPopup(false)}
      btnAction={() => {
        router.push(REDIRECT.client.activities);
      }}
    />
  );
}
